<div class="home-tasks-container">
  <p class="title">
    {{ 'HOME.TASK_LIST.TITLE' | translate }}
  </p>

  <p class="sub-title">
    {{ 'HOME.TASK_LIST.SUB_TITLE' | translate }}
  </p>

  <app-home-task-list
    class="task-list"
    [taskItems]="taskItems"
    [trackingScreenName]="trackingScreenName"
    (taskItemClick)="taskItemClick.emit($event)"
    (taskItemDismiss)="taskItemDismiss.emit($event)"
  >
  </app-home-task-list>
</div>
